import PubSub from "underpub-js";

var PrimaryNavigationLinks = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-PrimaryNavigationLinks',
	};

	$.extend(true, this.options, options);

};

PrimaryNavigationLinks.prototype.init = function() {

	var self = this;

};

export default PrimaryNavigationLinks;
